import { PrimaryContactFormProps, PremiseContactFormProps } from "./types";
import { useCustomerContacts } from "components/utils/useCustomerContacts";
import { ExistingContact } from "./ExistingContact";
import ContactFields from "./ContactFields";
import { ContactHeader } from "./ContactHeader";
import { getReqFields, needsFirstAndLastOrCompany } from "./utils";
import { isEmpty } from "lodash";
import { useLotLabel } from "./useLotLabel";

export const ContactForm = ({
    formData,
    idPrefix = "",
    errors,
    requiredFields = [],
    hiddenFields = [],
    hide = false,
    requirements,
    onChange,
    onUseCustomerContact,
    onCopyContact,
    onClearForm,
    contactType,
}: PremiseContactFormProps | PrimaryContactFormProps) => {
    // first name, last name, company
    const requiredFLC = getReqFields(requiredFields, formData);

    const [customerContacts = []] = useCustomerContacts(1, 100);
    const lotLabel = useLotLabel(contactType);

    const isExisting = !!customerContacts.some((c) => c.contactNumber === formData?.storedContactNumber) && isEmpty(errors);

    if (hide) {
        return null;
    }

    return (
        <div style={{ maxWidth: "925px" }} className="border bg-white mb-3 rounded-8 mx-auto">
            <ContactHeader
                idPrefix={idPrefix}
                contactType={contactType}
                onCopyContact={onCopyContact}
                formData={formData}
                customerContacts={customerContacts}
                onUseCustomerContact={onUseCustomerContact}
                requirements={requirements}
            />
            {isExisting && (
                <ExistingContact
                    onUseCustomerContact={onUseCustomerContact}
                    customerContacts={customerContacts}
                    contact={formData}
                    hiddenFields={hiddenFields}
                    lotLabel={lotLabel}
                />
            )}
            {!isExisting && (
                <ContactFields
                    onChange={(patch: Partial<typeof formData>) =>
                        onChange?.({
                            ...formData,
                            ...patch,
                        })
                    }
                    idPrefix={idPrefix}
                    formData={formData}
                    requiredFields={[...requiredFields.filter((s) => !["firstname", "lastname", "company"].includes(s)), ...requiredFLC]}
                    hiddenFields={hiddenFields}
                    errors={errors}
                    onClearForm={onClearForm}
                    lotLabel={lotLabel}
                    needsFirstAndLastOrCompany={needsFirstAndLastOrCompany(requiredFields)}
                />
            )}
        </div>
    );
};
